import { createReducer } from '../../helpers';

import { api } from '../../actions';

const initialState = {
    crm: {
        defaultCurrency: 'USD',
        onBoarding: false,
    },
};

export default createReducer(initialState, {
    [api.crm.settings.update.success]: (state, action) => {
        state.crm = action.result;
    },
});
